import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import SHNShield from 'images/icons/shgn/Shield.js'

const PoweredBy = styled.span`
  color: ${props => props.themeColor ? props.themeColor : '#FFF'};
  font-size: ${props => props.multiline ? '8px' : '10px'};
  display: flex;
  align-items: center;
  line-height: ${props => props.multiline ? '10px' : 'inherit'};
  text-align: ${props => props.multiline ? 'right' : 'inherit'};
  flex-direction: ${props => props.multiline ? 'column' : 'row'};

  p {
    margin: 0;
  }
`

const ShnShieldWrapper = styled.span`
  margin: 0 4px 0 0;
  display: block;
  align-self: flex-end;

  svg {
    height: 18px;
    width: 18px;
    fill: rgb(255, 255, 255)
  }
`

function NetworkTag (props) {
  const { themeColor, multiline } = props
  return (
    <PoweredBy themeColor={themeColor} multiline={multiline} >
      <ShnShieldWrapper>
        <SHNShield themeColor={themeColor} />
      </ShnShieldWrapper>
      {
        multiline === true
          ? <div><div>Powered By</div><div>THE SPORTSHUB GAMES NETWORK</div></div>
          : <span>POWERED BY THE SPORTSHUB GAMES NETWORK</span>
      }
    </PoweredBy>
  )
}

NetworkTag.propTypes = {
  themeColor: PropTypes.string,
  multiline: PropTypes.bool,
}

export default NetworkTag



// WEBPACK FOOTER //
// ./src/atoms/NetworkTag/NetworkTag.js